const $ = window.jQuery;
const $window = window.$window || $(window);
// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination } from "swiper";
import "../../../node_modules/swiper/swiper-bundle.min.css";

const Media = {
    init() {
        var $module = $(".recent-media");
        if (!$module.length) return;

        $module.each((index, element) => {
            this.each(element);
        });
    },

    each(element) {
        let $item = $(element);
        // Swiper carousel
        function carouselProperties() {
            return new Swiper(".media-carousel", {
                autoHeight: true, // enable auto height
                slidesPerView: 1,
                loop: true,
                speed: 500,
                breakpoints: {
                    768: {
                        slidesPerView: 3,
                    },
                },
                modules: [Navigation, Pagination],
                // Responsive breakpoints
            });
        }
        // if has logomarquee then run script

        // Here we define a variable that returns the swiper
        const carousel = carouselProperties();
        // Afte we define this variable we can finally call the init function
        carousel.init();
    },
};

export default Media;
